<template>
    <div class="vote" v-loading='proloading'>
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div></div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
                            新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <el-table :data="proData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="problem" label="分数范围" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.score_start}}~{{scope.row.score_end}}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                        @click="handleEdit(scope.row,scope.$index)"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                        @click="handleDelet(scope.row,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新建" :visible.sync="adddialogVisible" top="50px" width="50%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <div class="dialog-ibox-content"  v-loading='addloading'>
                <el-form :model="ruleForm" :rules="problems" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <div class="problem_box">
                        <el-form-item label="分数范围" style="margin-top:10px">
                            <el-input style="max-width:80px" v-model="ruleForm.minbum" size="small" type="number">
                            </el-input>
                            ~
                            <el-input style="max-width:80px" v-model="ruleForm.maxbum" size="small" type="number">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="内容模块">
                            <el-select v-model="ruleForm.jbxx_value" placeholder="请选择" size="small" filterable
                                clearable>
                                <el-option v-for="item in jbxx_options" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                            <el-button type="primary" @click="addJB" size="small" style="margin-left:10px">添加
                            </el-button>
                        </el-form-item>
                        <div v-for="(item,index) in list" :key="index">
                            <el-form-item :label="item.dimension_name" prop='lb_content'>
                                <tinymce ref="editor" v-model="item.dimension_content" :key="index+1"
                                    toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
                                <el-button type="primary" @click="delJB(index)" size="small" style="margin-left:10px">删除
                                </el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">确 定
                </el-button>
                <el-button @click="adddialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            // WangEditor,
            tinymce
        },
        data() {
            return {
                proData: [],
                textId: '',
                loading: false,
                subloading: false,
                height: null,
                adddialogVisible: false,
                ruleForm: {
                    minbum: '',
                    maxbum: '',
                    jbxx_value: '',


                    options: [{
                        option: "",
                        score: '',
                    }, ],

                },
                problems: {
                    problem: [{
                        required: true,
                        message: '问题必填',
                        trigger: 'blur'
                    }, ],
                    option: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                },
                eid: '',
                proloading: false,
                jbxx_options: [],
                list: [],
                addloading:false
            }
        },
        mounted() {
            this.getHeight()
            this.getinfoxx()
            // this.getlist()

        },
        methods: {
            getHeight() {
                let that = this

                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {

                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            handleAdd() {
                this.clearf()
                this.eid = ''
                this.adddialogVisible = true
            },
            clearf() {
                this.ruleForm = {
                    minbum: '',
                    maxbum: '',
                    jbxx_value: '',
                }
                this.list = []
            },
            getlist(id) {
                this.proData = []
                this.proloading = true
                axios
                    .post("/admin/pc/medicine/score/Mlist", {
                        category_id: id,

                    }, {
                        token: true
                    })
                    .then(response => {
                        this.proloading = false

                        if (response.data.code == '200') {
                            this.proData = response.data.data
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            handleEdit(row, index) {
                this.clearf()
                this.addloading=true
                axios
                    .post("/admin/pc/medicine/score/Mread", {
                        id: row.id,
                    }, {
                        token: true
                    })
                    .then(res => {
                       if (res.data.code==200) {
                           this.ruleForm.minbum=res.data.data.score_start+''
                           this.ruleForm.maxbum=res.data.data.score_end+''
                           this.list=res.data.data.dimension
                       }
                       this.addloading=false
                    })
                    .catch(error => {})

                this.eid = row.id
                this.adddialogVisible = true
            },
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该结果, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.proloading = true
                    axios
                        .post("/admin/pc/medicine/score/Mdel", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist(this.textId)
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.ruleForm.minbum == '') return this.$message('请添加分数最小值')
                        if (this.ruleForm.maxbum == '') return this.$message('请添加分数最大值')
                        if (this.list.length == 0) return this.$message('请添加显示维度')
                        let op_null = false
                        this.list.forEach(ele => {
                            if (ele.dimension_content == '') {
                                op_null = true
                                return
                            }
                        })
                        if (op_null) return this.$message.error('选项填写完整')
                        let urls
                        if (this.eid && this.eid != '') {
                            urls = "/admin/pc/medicine/score/Mupdate"
                        } else {
                            urls = "/admin/pc/medicine/score/Mcreate"
                        }
                        this.subloading = true
                        axios.post(urls, {
                                id: that.eid,
                                category_id: this.textId,
                                score_start: this.ruleForm.minbum,
                                score_end: this.ruleForm.maxbum,
                                dimensions: this.list,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.adddialogVisible = false
                                    that.getlist(this.textId)
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        // this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            getinfoxx() {
                let that = this
                axios
                    .post("/admin/knowledgecategory/categorySelect", {}, {
                        token: true
                    })
                    .then(response => {
                        that.jbxx_options = response.data.data
                    })
                    .catch(error => {})
            },
            addJB() {
                let that = this
                if (!this.ruleForm.jbxx_value) return that.$message('请选择内容模块');

                if (this.list.length > 0) {
                    var flag = false
                    this.list.forEach((element) => {
                        if (element.dimension_id == this.ruleForm.jbxx_value) {
                            flag = true
                        }
                    })
                }
                if (flag) return that.$message('不能选择重复的信息');
                var obj = {
                    dimension_id: '',
                    dimension_content: '',
                    dimension_name: ''
                }
                obj.dimension_id = this.ruleForm.jbxx_value
                obj.dimension_name = this.jbxx_options.find(element => {
                    return element.id == this.ruleForm.jbxx_value
                }).name
                obj.dimension_content = ''
                this.list.push(obj)
            },
            delJB(index) {
                this.list.splice(index, 1)
            },
        },
        watch: {
            'ruleForm.choose_type'(val, old) {
                if (val == 3) {
                    this.ruleForm.options = [{
                        option: "",
                        // option_type: 1,
                        score: '',
                    }]
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>